export default {
  GET_CHANNEL_MESSAGE_LIST_LOADING: 'GET_CHANNEL_MESSAGE_LIST_LOADING',
  GET_CHANNEL_MESSAGE_LIST_SUCCESS: 'GET_CHANNEL_MESSAGE_LIST_SUCCESS',
  GET_CHANNEL_MESSAGE_LIST_FAILED: 'GET_CHANNEL_MESSAGE_LIST_FAILED',
  GET_CHANNEL_MESSAGE_LIST_REJECT: 'GET_CHANNEL_MESSAGE_LIST_REJECT',

  GET_NEWS_LIST_LOADING: 'GET_NEWS_LIST_LOADING',
  GET_NEWS_LIST_SUCCESS: 'GET_NEWS_LIST_SUCCESS',
  GET_NEWS_LIST_FAILED: 'GET_NEWS_LIST_FAILED',
  GET_NEWS_LIST_REJECT: 'GET_NEWS_LIST_REJECT',
};